// eslint:disable max-line-length
import * as React from 'react';
import { UiState } from './types';
import { OverlayComponent } from 'app/components';
import styles from './form-context.scss';

export interface FormProps {
  translation: {submit: string; cancel: string; overlay_text: string};
  submit: () => any;
  cancel: () => any;
  children?: React.ReactNode;
}

export const FormContext: React.FC<FormProps & UiState> = ({
  editing,
  translation: text,
  children
}) => {

  return (
    <OverlayComponent
      displayOverlay={editing.submitting}
      overlayText={text.overlay_text}
    >
      <div className={styles.formContent}>
        <div className={styles.formBody}>
          <form key={'form-context-form'} noValidate>
            {children}
          </form>
        </div>
      </div>
    </OverlayComponent>
  );
};
